import { EntityManagementSettingProvider } from '../providers/entityManagementSettingProvider';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_USER_SETTINGS = new AsyncAction('GET_USER_SETTINGS');

export function getUserSettings(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        appInstanceId:  undefined,
        verbose: false,
        stdParameters: undefined,      
        refresh: false,
        emToken: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_USER_SETTINGS.base,
        payload: getUserSettingsAction(paramsObject)
    };
}

async function getUserSettingsAction({ baseUrl, authId, secret, appInstanceId, verbose, stdParameters, refresh, emToken }) {

    const op = new EntityManagementSettingProvider(baseUrl, authId, secret, { emToken });
    return await op.getUserSettings(appInstanceId, verbose, stdParameters, refresh);
}


export const UPDATE_USER_SETTINGS = new AsyncAction('UPDATE_USER_SETTINGS');

export function updateUserSettings(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        appInstanceId: undefined,
        verbose: false,
        stdParameters: undefined,      
        settings: undefined,
        emToken: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: UPDATE_USER_SETTINGS.base,
        payload: updateUserSettingsAction(paramsObject)
    };
}

async function updateUserSettingsAction({ baseUrl, authId, secret, appInstanceId, verbose, stdParameters, settings, emToken }) {

    const op = new EntityManagementSettingProvider(baseUrl, authId, secret, { emToken });
    return await op.updateUserSettings(appInstanceId, verbose, stdParameters, settings);
}

export const SET_USER_SETTING_DATA = 'SET_USER_SETTING_DATA';

export function setUserSettingsData(userSettings) {
    return {
        type: SET_USER_SETTING_DATA,
        payload:userSettings
    };
}
